import apiClient from '../../../api/apiClient';

export const getDashboardStatsApi = async (itSalesId, oemId = null) => {
  let url = `/partners/itsales-partner/dashboard/data?itSalesId=${itSalesId}`;
  if (oemId) {
    url += `&oemId=${oemId}`;
  }
  const response = await apiClient.get(url);
  return response.data.response;
};

export const getMonthlyScanStatsApi = async (itSalesId) => {
  const response = await apiClient.get(`/partners/itsales-partner/monthly-scan-stats/chart?itSalesId=${itSalesId}`);
  return response.data.response;
};

export const getLicenseUsageApi = async (itSalesId, licenseId) => {
  const response = await apiClient.get(`/partners/itsales-partner/licenses/usage/${itSalesId}/${licenseId}`);
  return response.data.response;
};